globalThis.Server = class Server extends EventTarget {
  constructor(resource) {
    super();
    this.abort = new AbortController();
    if (!resource) {
      const worker_url = new URL("../server/worker.js", import.meta.url);
      this.worker = new Worker(worker_url, { type: "module" });
      this.addEventListener = this.worker.addEventListener.bind(this.worker);
      this.postMessage = this.worker.postMessage.bind(this.worker);
      this.onOpen();
    } else if (resource instanceof URL) {
      this.socket = new WebSocket(resource);
      this.socket.addEventListener("open", this.onOpen.bind(this));
      this.socket.addEventListener("close", this.onClose.bind(this));
      this.socket.addEventListener(
        "message",
        this.onMessage.bind(this),
        this.abort,
      );
    }
  }

  remove() {
    this.abort.abort();
    this.worker?.terminate();
    this.socket?.close();
  }

  onOpen() {
    this.open = true;
    this.dispatchEvent(new Event("open"));
  }

  onClose() {
    this.dispatchEvent(new Event("close"));
  }

  onMessage({ data }) {
    const event = new Event("message");
    event.data = JSON.parse(data);
    this.dispatchEvent(event);
  }

  postMessage(msg) {
    if (this.socket.readyState !== 1) return;
    this.socket.send(JSON.stringify(msg));
  }
};
